exports.violationTypes = ["CONSTRUCTION_VEHICLE", "COMPANY","MUNICIPAL_VEHICLE", "PRIVATE_VEHICLE", "TAXI", "OTHER"];